import React from 'react';
export const StorySection = () => {
  return <section data-id="element-160">
      <div className="mb-6" data-id="element-161">
        <a href="https://petssey.com/products/petssey-dnrx" data-id="element-162">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jdYjmCe7XVTuqy4DJEh2mX/ChatGPT_Image_Aug_28%2C_2025%2C_02_23_49_PM.png" alt="Gray cat being groomed with fur being removed" className="w-full h-auto object-cover rounded mb-4" data-id="element-163" />
        </a>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-164">
          <span className="topcap" style={{
          fontSize: '32px'
        }} data-id="element-165">
            <strong data-id="element-166">M</strong>
          </span>
          argaret W., 74, never imagined the cat dander in her Brisbane home
          would nearly kill her.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-167">
          Happily retired, her greatest joy was spending time with her beloved
          tabby, Mittens. She often entertained friends in her cosy Ashgrove
          lounge room with Mittens by her side... until something terrible
          happened.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-168">
          One afternoon, while brushing Mittens' coat and hosting her weekly
          book club, Margaret noticed an intense tickle deep inside her nose.
          She brushed it off as nothing, but then she sneezed so violently, her
          entire chest convulsed against her ribs. CRIKEY! She quickly grabbed a
          tissue and some antihistamines, but little did she know it was too
          late...
        </p>
        <img src="https://media.giphy.com/media/cWO07IvGPQXeaNF7P8/giphy.gif" alt="Gray cat being groomed with fur being removed" className="w-full h-auto object-cover rounded mb-4" data-id="element-169" />
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-170">
          As she desperately tried to stifle her sneezes, a crushing tightness
          gripped her chest and— she couldn't breathe!
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-171">
          She felt the room spinning beneath her and her vision began to blur.
          She dropped to her knees, gasping for air, too dizzy to even stand.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-172">
          "The chest pain was frightening," Margaret recalls. "But the
          embarrassment of collapsing in front of my book club was unbearable."
        </p>
        <p className="text-[22px] italic text-[#323232] mb-4" data-id="element-173">
          I couldn't stop wheezing, it felt like my airways were closing, and my
          breathing became so laboured my friends nearly rang 000.
        </p>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7ui1kkcKF8NCkTJUX8mict/ca6b2e129ae0ab02278b6c4904b4a21e.jpg" alt="Smartphone emergency dialing screen showing 000" className="w-full h-auto object-cover rounded mb-4" data-id="element-174" />
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-175">
          A couple of days later, Margaret started experiencing persistent
          shortness of breath, and her lungs felt like they were clogged with
          thick mud...
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-176">
          The chest tightness and sinus pressure didn't subside either...
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-177">
          With so many health risks associated with breathing difficulties,
          chronic allergies, and chest pain, Margaret decided to see her GP.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-178">
          The first thing Dr. Harrison asked was whether she owned a cat because
          he'd seen many patients with identical symptoms. And they all had
          cats.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-179">
          The doctor explained it was a severe reaction to the invisible cat
          dander floating through her home and that fortunately, it wasn't
          something more serious.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-180">
          "But what if it had been worse," she thought, — "all because of the
          cat dander from my precious Mittens contaminating my home."
        </p>
      </div>
      <a href="https://petssey.com/products/petssey-dnrx" data-id="element-181">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mToGguWmLutQBtAwWbTPwG/ChatGPT_Image_Sep_2%2C_2025%2C_10_07_29_PM.png" alt="Woman holding her tabby cat with visible Fel d1 allergen particles floating around them" className="w-full h-auto object-cover rounded mb-4" data-id="element-182" />
      </a>
      <div className="mb-6" data-id="element-183">
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-184">
          Little do cat parents know that every time a cat grooms, it leaves
          behind a sticky protein called Fel d1. Once it dries, it breaks into
          particles so tiny they float invisibly through the air for months.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-185">
          You can vacuum every day, dust until your arms ache, and spray air
          fresheners — but those invisible particles still drift around your
          home for weeks, sneaking straight into your lungs.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-186">
          That's why Margaret's eyes watered, her chest tightened, and her
          friends noticed the "cat smell" even after hours of cleaning.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-187">
          Her doctor explained that cat parents are most at risk because even if
          they showed no allergic symptoms previously, their mild sensitivity to
          cat dander can rapidly escalate into a serious health threat the
          longer they live with cats and breathe in cat dander⁴.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-188">
          Margaret isn't alone: 20% of Australians are allergic to cats (and
          this number keeps growing)⁵.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-189">
          Her doctor asked if she'd consider rehoming her cat, but Margaret said
          she absolutely couldn't.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-190">
          In fact, 84% of cat parents said they would dismiss their doctor's
          advice to rehome their pet⁶... and 20% would even consider finding a
          new doctor instead⁷.
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-191">
          "Unfortunately for me, it took years of suffering to finally
          understand how dangerous cat dander truly is. It wasn't just the
          physical discomfort from the chest pain and crushing sneezes, it was
          the fear of losing my greatest source of happiness - my afternoon teas
          with friends, family visits, and of course... precious Mittens."
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-192">
          "I wish I'd known about the threat of cat dander sooner..."
        </p>
      </div>
      <div className="mb-6" data-id="element-193">
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-194">
          Margaret knew she had to do something to eliminate the cat dander from
          her home's air so she could host visitors again without giving Mittens
          up to a shelter. Immediately, she started researching every option she
          could find: expensive air purifiers, professional cleaning services,
          and even those fancy robotic vacuum cleaners.
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-195">
          "That's when the real nightmare began," Margaret said. "I rang a
          professional cleaning service and they wanted to charge $900 just for
          one visit! Completely out of my budget. And I'd have to keep paying
          them every time the dander built up again."
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-196">
          "So I went online and ordered one of those massive tower air purifiers
          for $800. What a complete waste of money. It roared like a jet engine,
          took up half my living room, and after just weeks of use, it was
          demanding another $150 for a replacement filter. After weeks of no
          improvement in my symptoms, I realised it wasn't solving the core
          problem... It barely made a dent in the airborne allergens. The cat
          dander still circulated through my air, triggering my painful allergic
          reactions."
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-197">
          Margaret sighed. "That was the worst part — not just the wasted money,
          but the disappointment. These machines promise to clean your air, but
          in reality, they're bulky, noisy, and they never deal with the tiniest
          particles that cause the real misery. They're built to look
          impressive, not to actually solve the problem."
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-198">
          Running out of options, Margaret faced an impossible choice: keep
          pouring effort into solutions that left her frustrated, or surrender
          her beloved Mittens to a shelter.
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" data-id="element-199">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gDSrgkofQ2Ve27xg2zdrjH/dstx-s43-img2.webp" alt="Black and white cat walking on carpet with baking soda" className="w-full h-auto object-cover rounded mb-4" data-id="element-200" />
        </a>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-201">
          But this retired grandmother was about to discover her answer from a
          neighbour... literally.
        </p>
      </div>
    </section>;
};